const FETCH_PROGRAM_BOOK_DOWNLOADS = 'fetch_programBookDownloads';

const FETCH_PROGRAM_BOOK_DOWNLOAD = 'fetch_programBookDownload';
const DELETE_PROGRAM_BOOK_DOWNLOAD = 'delete_programBookDownload';
const PERSIST_PROGRAM_BOOK_DOWNLOAD = 'persist_programBookDownload';
export default {
    FETCH_PROGRAM_BOOK_DOWNLOADS,
    FETCH_PROGRAM_BOOK_DOWNLOAD,
    DELETE_PROGRAM_BOOK_DOWNLOAD,
    PERSIST_PROGRAM_BOOK_DOWNLOAD,
};
